import { render, staticRenderFns } from "./newFile.vue?vue&type=template&id=5def58e8&"
import script from "./newFile.vue?vue&type=script&lang=js&"
export * from "./newFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports